import React, { useState } from 'react';
import { auth } from '../config/firebase';
import { signOut } from 'firebase/auth';

function AdminPanel() {
  const [activeTab, setActiveTab] = useState('students');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 顶部导航 */}
      <nav className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div>
            <h1 className="text-xl font-bold">Staff Admin Panel</h1>
            <p className="text-sm text-gray-400">MyDriveBook Management System</p>
          </div>
          <button
            onClick={() => signOut(auth)}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
          >
            Sign Out
          </button>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* 标签页切换 */}
        <div className="flex gap-2 mb-6 overflow-x-auto">
          {[
            { id: 'students', label: 'Student Management', icon: '👨‍🎓' },
            { id: 'instructors', label: 'Instructor Management', icon: '👨‍🏫' },
            { id: 'schedule', label: 'Schedule', icon: '📅' },
            { id: 'analytics', label: 'Analytics', icon: '📊' },
            { id: 'settings', label: 'Settings', icon: '⚙️' }
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-colors ${
                activeTab === tab.id
                  ? 'bg-blue-600 text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              }`}
            >
              {tab.icon} {tab.label}
            </button>
          ))}
        </div>

        {/* 内容区域 */}
        <div className="card">
          {activeTab === 'students' && <StudentManagement />}
          {activeTab === 'instructors' && <InstructorManagement />}
          {activeTab === 'schedule' && <ScheduleManagement />}
          {activeTab === 'analytics' && <Analytics />}
          {activeTab === 'settings' && <SystemSettings />}
        </div>
      </div>
    </div>
  );
}

// 学员管理子组件
function StudentManagement() {
  const [showAddForm, setShowAddForm] = useState(false);

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold">Student Management</h2>
        <button
          onClick={() => setShowAddForm(true)}
          className="btn-primary"
        >
          ➕ Add New Student
        </button>
      </div>

      {/* 搜索栏 */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search Student ID, Name..."
          className="input max-w-md"
        />
      </div>

      {/* 学员列表 */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-left">Student ID</th>
              <th className="px-4 py-2 text-left">Name</th>
              <th className="px-4 py-2 text-left">Contact</th>
              <th className="px-4 py-2 text-left">Progress</th>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {/* TODO: 从 Firebase 加载数据 */}
            <tr className="border-b">
              <td className="px-4 py-3">JS-2024-001</td>
              <td className="px-4 py-3">John Zhang</td>
              <td className="px-4 py-3">555-1234</td>
              <td className="px-4 py-3">75%</td>
              <td className="px-4 py-3"><span className="badge badge-success">Active</span></td>
              <td className="px-4 py-3">
                <button className="text-blue-600 hover:text-blue-700 text-sm">View Details</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* 添加学员表单 (简化版) */}
      {showAddForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">Add New Student</h3>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Full Name</label>
                <input type="text" className="input" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Phone</label>
                <input type="tel" className="input" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Email</label>
                <input type="email" className="input" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Language Preference</label>
                <select className="input">
                  <option>English</option>
                  <option>中文</option>
                  <option>Español</option>
                </select>
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium mb-1">Notes</label>
                <textarea className="input" rows="3"></textarea>
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => {
                  alert('Student created successfully! Student ID: JS-2024-002');
                  setShowAddForm(false);
                }}
                className="btn-primary flex-1"
              >
                Create Student
              </button>
              <button
                onClick={() => setShowAddForm(false)}
                className="btn-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// 其他子组件简化实现
function InstructorManagement() {
  return <div className="text-center py-12 text-gray-500">Instructor Management - Coming Soon...</div>;
}

function ScheduleManagement() {
  return <div className="text-center py-12 text-gray-500">Schedule Management - Coming Soon...</div>;
}

function Analytics() {
  return <div className="text-center py-12 text-gray-500">Analytics Dashboard - Coming Soon...</div>;
}

function SystemSettings() {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-6">System Settings</h2>
      <div className="space-y-4">
        <div className="p-4 border border-gray-200 rounded-lg">
          <h3 className="font-medium mb-2">Google Calendar Integration</h3>
          <button className="btn-secondary text-sm">Configure Calendar API</button>
        </div>
        <div className="p-4 border border-gray-200 rounded-lg">
          <h3 className="font-medium mb-2">OpenAI API Settings</h3>
          <button className="btn-secondary text-sm">Configure API Key</button>
        </div>
        <div className="p-4 border border-gray-200 rounded-lg">
          <h3 className="font-medium mb-2">Google Sheets Sync</h3>
          <button className="btn-secondary text-sm">Test Connection</button>
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;
